export default "__VITE_ASSET__BM_QwHnb__"